import { useState } from 'react';

const useMediaState = () => {
  const [mediaState, setMediaState] = useState({
    messageMediaIds: {},      // 存储消息媒体ID
    messageImageIds: {},      // 存储消息图片ID
    messageVideoIds: {},      // 存储消息视频ID
    messageFileIds: {},       // 存储消息文件ID
    messageOssUrls: {},       // 存储消息媒体OSS URL
    messageImageGroupIds: {}, // 存储图片集媒体ID，格式: {boxId: {mediaIds: [], ossUrls: {}}}
    momentMediaIds: {},       // 存储朋友圈媒体ID
    momentImageIds: {},       // 存储朋友圈图片ID
    momentVideoIds: {},       // 存储朋友圈视频ID
    momentOssUrls: {},        // 存储朋友圈媒体OSS URL
    momentImageGroupIds: {}   // 存储朋友圈图片集媒体ID，格式: {boxId: {mediaIds: [], ossUrls: {}}}
  });

  // 更新通用媒体ID
  const updateMediaId = (boxId, mediaId, stepType = 'MESSAGE') => {
    const stateKey = stepType === 'MESSAGE' ? 'messageMediaIds' : 'momentMediaIds';
    setMediaState(prev => ({
      ...prev,
      [stateKey]: {
        ...prev[stateKey],
        [boxId]: mediaId
      }
    }));
  };

  // 更新专用媒体ID（根据类型）
  const updateSpecificMediaId = (boxId, mediaId, mediaType, stepType = 'MESSAGE') => {
    const prefix = stepType === 'MESSAGE' ? 'message' : 'moment';
    let stateKey;
    
    switch (mediaType) {
      case 'image':
        stateKey = `${prefix}ImageIds`;
        break;
      case 'video':
        stateKey = `${prefix}VideoIds`;
        break;
      case 'file':
        stateKey = `${prefix}FileIds`;
        break;
      default:
        return;
    }

    setMediaState(prev => ({
      ...prev,
      [stateKey]: {
        ...prev[stateKey],
        [boxId]: mediaId
      }
    }));
  };

  // 更新OSS URL
  const updateOssUrl = (boxId, ossUrl, stepType = 'MESSAGE') => {
    const stateKey = stepType === 'MESSAGE' ? 'messageOssUrls' : 'momentOssUrls';
    setMediaState(prev => ({
      ...prev,
      [stateKey]: {
        ...prev[stateKey],
        [boxId]: ossUrl
      }
    }));
  };

  // 更新图片集
  const updateImageGroup = (boxId, imageGroup, stepType = 'MESSAGE') => {
    const stateKey = stepType === 'MESSAGE' ? 'messageImageGroupIds' : 'momentImageGroupIds';
    setMediaState(prev => ({
      ...prev,
      [stateKey]: {
        ...prev[stateKey],
        [boxId]: imageGroup
      }
    }));
  };

  // 清除媒体数据
  const clearMedia = (boxId, stepType = 'MESSAGE') => {
    const prefix = stepType === 'MESSAGE' ? 'message' : 'moment';
    
    setMediaState(prev => {
      const newState = { ...prev };
      
      // 清除所有相关的媒体ID
      const keysToUpdate = [
        `${prefix}MediaIds`,
        `${prefix}ImageIds`, 
        `${prefix}VideoIds`,
        `${prefix}FileIds`,
        `${prefix}OssUrls`,
        `${prefix}ImageGroupIds`
      ];
      
      keysToUpdate.forEach(key => {
        if (newState[key] && newState[key][boxId]) {
          const newKeyState = { ...newState[key] };
          delete newKeyState[boxId];
          newState[key] = newKeyState;
        }
      });
      
      return newState;
    });
  };

  // 从图片集中移除指定的mediaId
  const removeFromImageGroup = (boxId, mediaId, stepType = 'MESSAGE') => {
    const stateKey = stepType === 'MESSAGE' ? 'messageImageGroupIds' : 'momentImageGroupIds';
    
    setMediaState(prev => {
      const currentImageGroup = prev[stateKey][boxId] || { mediaIds: [], ossUrls: {} };
      
      const newImageGroup = {
        mediaIds: currentImageGroup.mediaIds.filter(id => id !== mediaId),
        ossUrls: { ...currentImageGroup.ossUrls }
      };
      
      // 删除ossUrl对应项
      delete newImageGroup.ossUrls[mediaId];
      
      return {
        ...prev,
        [stateKey]: {
          ...prev[stateKey],
          [boxId]: newImageGroup
        }
      };
    });
  };

  return {
    mediaState,
    setMediaState,
    updateMediaId,
    updateSpecificMediaId,
    updateOssUrl,
    updateImageGroup,
    clearMedia,
    removeFromImageGroup
  };
};

export default useMediaState;